import {
  ICategorySoldProducts,
  ISoldProducts,
  TComplexSectionData,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'

interface IDeleteProduct {
  updateFormData: (data: TComplexSectionData) => void
  data: ICategorySoldProducts[]
  product: ISoldProducts
  productCategory: ICategorySoldProducts
}
export const deleteProduct = ({
  updateFormData,
  data,
  productCategory,
  product,
}: IDeleteProduct) => {
  const updatedData = [...data]

  const foundCategoryIndex = updatedData.findIndex((el) => el.Key === productCategory.Key)

  const foundProductCategory = updatedData[foundCategoryIndex].Products.findIndex(
    (el) => el.Key === product.Key
  )
  if (updatedData[foundCategoryIndex].Products.length === 1) {
    updatedData.splice(foundCategoryIndex, 1)
    updateFormData(updatedData)
    return
  }

  updatedData[foundCategoryIndex].Products.splice(foundProductCategory, 1)

  updateFormData(updatedData)
}
